document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.horeca-section').forEach(function(section){
    var tabs = section.querySelectorAll('.horeca-tab');
    var hidden = section.querySelector('#HorecaRequestType');
    var select = section.querySelector('#HorecaRequirement');
    var map = { sample:'Request HORECA Sample', bulk:'Get Bulk Quote', catalogue:'Request HORECA Catalogue' };

    function setRequest(key, updateUrl){
      if(!map[key]) key='sample';
      tabs.forEach(function(tab){
        var active = tab.dataset.request === key;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if(hidden) hidden.value = map[key];
      if(select) select.value = map[key];
      if(updateUrl && window.history && history.replaceState){
        var url = new URL(window.location.href);
        url.searchParams.set('request', key);
        url.hash='horeca-enquiry';
        history.replaceState({}, '', url.toString());
      }
    }

    var key = new URLSearchParams(window.location.search).get('request') || 'sample';
    setRequest(key, false);
    tabs.forEach(function(tab){
      tab.addEventListener('click', function(e){
        e.preventDefault();
        setRequest(tab.dataset.request, true);
      });
    });
    if(select){
      select.addEventListener('change', function(){
        var found = Object.keys(map).find(function(k){return map[k] === select.value;}) || 'sample';
        setRequest(found, true);
      });
    }
  });
});
